import React from 'react'
import styled from '@emotion/styled'
import { colors } from '@mobi/component-library/Foundations'

export const Highlight: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  return <HighlightStyled>{children}</HighlightStyled>
}

// ======
// Styles
// ======

const HighlightStyled = styled.span({
  position: 'relative',
  color: colors.studio[600],
  zIndex: 1,

  flex: '0 1 auto',
  minWidth: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',

  '::before': {
    content: '""',
    position: 'absolute',
    top: '-0.2em',
    bottom: '-0.2em',
    left: '-0.1em',
    right: '-0.1em',
    zIndex: -1,
    backgroundColor: '#F2ECF7',
  },
})
